// biome-ignore lint/correctness/noUnusedImports: JSX requires React in scope
import React from 'react';
import '@babel/polyfill';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { hashHistory, IndexRedirect, Route, Router } from 'react-router';
import ChangePassword from './components/change-password';
import Customer from './components/customer';
import Invoices from './components/invoices';
import Login from './components/login';
import Root from './components/root';
import Subscriptions from './components/subscriptions';
import configureStore from './configure-store';
import { getApiUrl } from './utils/network';
import { getAuthToken, saveAuthTokenFromQueryString } from './utils/session';

function requireAuth(_, replace) {
  if (!getAuthToken()) {
    replace({ pathname: '/login' });
  }
}

function noAuth(_, replace) {
  if (getAuthToken()) {
    replace({ pathname: '/' });
  }
}

function getTokenValue() {
  var reg = /[?&]authToken=([^&#]*)/i;
  var string = reg.exec(window.location.href);
  return string ? string[1] : null;
}

window.onerror = (message, url, line, col, error) => {
  try {
    const errorUrl =
      getApiUrl() +
      '/error' +
      '?message=' +
      encodeURIComponent(message) +
      '&url=' +
      encodeURIComponent(url) +
      '&line=' +
      encodeURIComponent(line) +
      '&col=' +
      encodeURIComponent(col) +
      '&error=' +
      encodeURIComponent(error);

    if (line && col && error) {
      const image = new Image();
      image.src = errorUrl;
    }
  } catch (e) {
    console.error('Failed to send error report', e);
  }
};

function renderWidget() {
  var token = getTokenValue();
  if (token !== null) {
    saveAuthTokenFromQueryString(token);
  }

  ReactDOM.render(
    <Provider store={configureStore()}>
      <Router history={hashHistory}>
        <Route path="/" component={Root}>
          <IndexRedirect to="/customer" />
          <Route path="customer" component={Customer} onEnter={requireAuth} />
          <Route
            path="subscriptions"
            component={Subscriptions}
            onEnter={requireAuth}
          />
          <Route path="invoices" component={Invoices} onEnter={requireAuth} />
          <Route
            path="changePassword"
            component={ChangePassword}
            onEnter={requireAuth}
          />
          <Route path="login" component={Login} onEnter={noAuth} />
        </Route>
      </Router>
    </Provider>,
    document.getElementById('my-pages'),
  );
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderWidget);
} else {
  renderWidget();
}
